import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal } from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_CSTM_OFCR_CD_SRCH, SCHEMA_GRID_CSTM_OFCR_CD } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const CustomsOfficerCodeList = (props: any) => {
    const pgeUid = "cstmOfcrCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        cstmOfcrCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_CSTM_OFCR_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        cstmOfcrCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_CSTM_OFCR_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmOfcrCdList: useFetch({
            api: (page = grid.cstmOfcrCdLst.page) => {
                return APIS.getCstmOfcrCdList(form.cstmOfcrCdSrch.getValues(), page, grid.cstmOfcrCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.cstmOfcrCdSrch.errors) && form.cstmOfcrCdSrch.isSubmitted,
            key: [grid.cstmOfcrCdLst.page, grid.cstmOfcrCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmOfcrCdSrch.getValues(),
                    page: grid.cstmOfcrCdLst.page,
                    size: grid.cstmOfcrCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.cstmOfcrCdSrch.handleSubmit(
                () => {
                    grid.cstmOfcrCdLst.setPage(0);
                    fetch.getCstmOfcrCdList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.cstmOfcrCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_CstmOfcrCdLst: {
            cell: {
                usrDmnId: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({
                                    code: value,
                                    label: rowValues.usrNm,
                                    cstmOfceCd: rowValues.cstmOfceCd,
                                });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.cstmOfceCd) {
            form.cstmOfcrCdSrch.setValue("cstmOfceCd", params.cstmOfceCd);
        }
        if (params?.usrStatCd) {
            form.cstmOfcrCdSrch.setValue("usrStatCd", params.usrStatCd);
        }
        if (params?.roleId) {
            form.cstmOfcrCdSrch.setValue("roleId", params.roleId);
        }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.cstmOfcrCdLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_CSTM_OFCR_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.cstmOfcrCdSrch.schema.usrDmnId}></Group.Control>
                                <Group.Control {...form.cstmOfcrCdSrch.schema.usrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.cstmOfcrCdSrch.schema.cstmOfceCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.cstmOfcrCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.cstmOfcrCdLst.grid}
                            data={fetch.getCstmOfcrCdList.data?.cstmCdList}
                            render={render.grid_CstmOfcrCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
